import { withStyles } from "@material-ui/core/styles";
import Dialog from "./Dialog";
import styles from "./styles";

export default withStyles(styles)(Dialog);
